import { ClassTimestampsHelper } from '../ClassHelper';
import Account from '../account/Account';
import AccountObject from './AccountObject';
import ObjectServicePrice from '../accountObjectService/ObjectServicePrice';

class AccountObjectService extends ClassTimestampsHelper {
  constructor({ account, accountObject, title, description, prices = [], status } = {}) {
    super(...arguments);
    this.account = this.ref(account, Account);
    this.accountObject = this.ref(accountObject, AccountObject)
    this.title = title;
    this.description = description;
    this.prices = this.array(prices, ObjectServicePrice);
    this.status = status; // Status
  }
}

export default AccountObjectService;